<template>
  <div class="flex flex-col items-stretch gap-2">
    <JoszakiButton
      type="info"
      inverted
      outline
      :to="
        localePath({
          name: 'professionalRatingPage',
          params: {
            professionalSeoName: person.seoName,
          },
        })
      "
    >
      {{ $t("profileAction.rateMate") }}
    </JoszakiButton>
    <JoszakiButton type="danger" inverted outline @click="reportPerson">
      {{ $t("profileAction.reportMate") }}
    </JoszakiButton>
  </div>
</template>

<script>
export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  methods: {
    reportPerson() {
      this.$nuxt.$emit("report-person");
    },
  },
};
</script>
